module.exports = __webpack_public_path__ + "img/luk_CM_logo_rus.06cbc714.svg";